module.exports = __webpack_public_path__ + "img/functions_inactive.c6216062.svg";